<template>
  <ChecklistBlockBase
    :buttonsPreset="'edit'"
    @edit="startUpload"
    :buttonsData="editorMetadata.buttonsData"
    @commonAction="(action) => $emit('commonAction', action)"
  >
    <div class="document-file qrw-box-shadow-1dp" v-if="block.document.url">
      <div class="document-file-inner">
        <BaseIcon :size="null" style="font-size: 36px" icon="file-attachment" />
        <div class="gap-row-zero w-100" v-if="hasFile">
          <a
            :href="block.document.url"
            target="_blank"
            class="qrw-label-md qrw-text-content-base-primary file-link"
          >
            {{ block.document.name }}
          </a>
          <div class="qrw-label-xs qrw-text-content-base-secondary">
            {{ prettyFileSize }}
          </div>
        </div>
        <div class="gap-row-zero w-100" v-else>
          <div class="qrw-label-lg qrw-text-content-base-secondary">
            {{ busy ? "Uploading..." : "No file uploaded" }}
          </div>
        </div>
      </div>
    </div>

    <PresignedFileUploader
      acceptFilter=".jpg,.png,.gif,.svg,.jpeg,.webp,.pdf,.docx,.txt,.doc,.xlsx,.rtf,.zip,.rar"
      ref="uploader"
      resourceType="checklist_assets"
      :sizeLimit="25 * 1024 * 1024"
      @uploaded="onUploadFinished"
      @cancel="onUploadCancelled"
      @startedUpload="busy = true"
    />
  </ChecklistBlockBase>
</template>

<script>
import ChecklistBlockBase from "./ChecklistBlockBase.vue";

import PresignedFileUploader from "@/components/PresignedFileUploader.vue";

export default {
  props: {
    block: Object,
    editorMetadata: Object
  },
  data() {
    return {
      busy: false,
    };
  },
  components: {
    ChecklistBlockBase,
    PresignedFileUploader,
  },
  methods: {
    startUpload() {
      if (this.busy) return;
      this.$refs.uploader.showUploadDialog();
    },
    onUploadFinished(url, metadata) {
      this.$set(this.block, "document", {
        name: metadata.filename,
        size: metadata.size,
        url,
      });
      this.busy = false;
    },
    onUploadCancelled() {
      if (!this.block.document.url) this.$emit("commonAction", "delete");
    },
  },
  computed: {
    hasFile() {
      return !!this.block.document.url;
    },
    prettyFileSize() {
      if (!this.block.document.size) return 0;

      let value = this.block.document.size;
      let suffix = "B";

      if (value > 1024 * 1024) {
        suffix = "MB";
        value = Math.round(value / (1024 * 1024));
      } else if (value > 1024) {
        suffix = "KB";
        value = Math.round(value / 1024);
      }

      return `${value} ${suffix}`;
    },
  },
  mounted() {
    if (!this.block.document.url) {
      this.startUpload();
    }
  }
};
</script>

<style scoped>
.document-file {
  display: flex;
  flex-direction: row;

  padding: 4px;
  column-gap: 4px;
  border-radius: 8px;

  align-items: center;
}

.document-file-inner {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  padding: 2px 8px;
  align-items: center;
}

.file-link {
  text-decoration: none;
}
</style>
